import { languageMap } from ".."
import { bracketIndenting } from "./shared"

languageMap.toml = bracketIndenting({
	line: "#",
})
